import {
  selectSlotRecipe
} from "./chunk-3TLKXH5F.mjs";
import {
  createStyleContext
} from "./chunk-7AJJGGQG.mjs";

// src/components/select/styled-components.ts
import { Select } from "@ark-ui/react";
var { withContext, withProvider } = createStyleContext(selectSlotRecipe);
var Root = withProvider(Select.Root, "root");
var Label = withContext(Select.Label, "label");
var Control = withContext(Select.Control, "control");
var Trigger = withContext(Select.Trigger, "trigger");
var ValueText = withContext(Select.ValueText, "valueText");
var Indicator = withContext(Select.Indicator, "indicator");
var ClearTrigger = withContext(Select.ClearTrigger, "clearTrigger");
var IndicatorGroup = withContext("div", "indicatorGroup");
var Content = withContext(Select.Content, "content");
var Item = withContext(Select.Item, "item");
var ItemIndicator = withContext(Select.ItemIndicator, "itemIndicator");
var StyledSelect = Object.assign(Root, {
  Label,
  Control,
  Trigger,
  ValueText,
  Indicator,
  ClearTrigger,
  IndicatorGroup,
  Content,
  Item,
  ItemIndicator
});

export {
  StyledSelect
};
